// extracted by mini-css-extract-plugin
module.exports = {"watchlist":"styles_watchlist__2PUQr","controls":"styles_controls__2e4bl"};